<section>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close"
        (click)="modalService.close()"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop"
          colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px">
        </lord-icon>
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>Are you sure you want to Delete?</h4>
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modalService.close()">Cancel
        </button>
        <button type="button" class="btn w-sm btn-danger " id="delete-product" (click)="delete()">Delete
        </button>
      </div>
    </div>
  </div>
</section>